module.exports = __webpack_public_path__ + "static/vagabonding-9b1c310242915a9584338c2ab5f45233.jpg";